export const spacings = {
  atom: '2px',
  bit: '4px',
  byte: '8px',
  kilo: '12px',
  mega: '16px',
  giga: '20px',
  tera: '28px',
  peta: '40px',
  exa: '48px',
  zetta: '60px',
  yotta: '87px',
};
